import ShippingId from '@/components/Shippings/ListItemId'
import ShippingExternalId from '@/components/Shippings/ListItemExternalId'
import ListItemFullPath from '@/components/ShippingFiles/ListItemFullPath'
import ListItemExtracted from '@/components/ShippingFiles/ListItemExtracted'
import EditFieldShippingFilesMeta from '@/components/ShippingFiles/EditFieldShippingFilesMeta'
import EditFieldShippingFilesContentStatus from '@/components/ShippingFiles/EditFieldShippingFilesContentStatus'

export default {
  computed: {
    ocrControlModel() {
      return {
        title: this.$gettext('Shipment Files OCR'),
        endpoint: this.$appConfig.api.baseUrl + 'shipping-photos',
        localEdit: true,
        fields: [
          {
            key: 'id',
            label: this.$gettext('ID'),
            editable: false
          },
          {
            key: 'full_path',
            sortable: false,
            editable: false,
            label: this.$gettext('File'),
            required: false,
            component: (value, key, item) => {
              return {
                is: ListItemFullPath,
                attachment: item
              }
            },
            componentEdit: (value, key, item) => {
              return {
                is: ListItemFullPath,
                props: {
                  attachment: item
                }
              }
            }
          },
          {
            key: 'meta',
            editable: true,
            componentEdit: (value, key, item) => {
              return {
                is: EditFieldShippingFilesMeta,
                props: {
                  file: item
                }
              }
            }
          },
          {
            key: 'document_type',
            hidden: true,
            editable: false,
            label: this.$gettext('Document Type'),
            formatter: (value, key, item) => {
              return !item.meta ? '-' : item.meta.meta?.document_type || this.$gettext('Not recognized')
            }
          },
          {
            key: 'checkpoints',
            hidden: true,
            editable: false,
            label: this.$gettext('Origin/Destination'),
            formatter: (value, key, item) => {
              let html = '<div class="mb-2">'
              if (item.shipping.meta?.geofences?.from) {
                html += `<strong>${item.shipping.meta.geofences.from.external_id}</strong> ${item.shipping.meta.geofences.from.name}`
              } else {
                html += item.shipping.address_from.formatted_address
              }
              html += '</div><div>'
              if (item.shipping.meta?.geofences?.to) {
                html += `<strong>${item.shipping.meta.geofences.to.external_id}</strong> ${item.shipping.meta.geofences.to.name}`
              } else {
                html += item.shipping.address_to.formatted_address
              }
              html += '</div>'
              return html
            }
          },
          {
            key: 'extracted_values',
            hidden: true,
            editable: false,
            label: this.$gettext('Extracted Values'),
            component: (value, key, item) => {
              return {
                is: ListItemExtracted,
                file: item
              }
            }
          },
          {
            key: 'shipping_id',
            sortable: false,
            editable: false,
            label: this.$gettext('Shipment ID'),
            component: (value, key, item) => {
              return {
                is: ShippingId,
                shipping: {id: item.shipping_id}
              }
            },
            componentEdit: (value, key, item) => {
              return {
                is: ShippingId,
                props: {
                  shipping: {id: item.shipping_id}
                }
              }
            }
          },
          {
            key: 'external_id',
            hidden: true,
            editable: false,
            label: this.$gettext('External ID'),
            component: (value, key, item) => {
              return {
                is: ShippingExternalId,
                shipping: item.shipping
              }
            }
          },
          {
            key: 'content_status',
            label: this.$gettext('Review Status'),
            editable: true,
            formatter: (value, key, item) => {
              return this.models.ocrControl.fields.find(x => x.key === 'content_status')
                .componentEdit().props.options.find(x => x.value === value).text
            },
            componentEdit: (value, key, item) => {
              return {
                is: EditFieldShippingFilesContentStatus,
                props: {
                  file: item,
                  options: [
                    {
                      text: this.$gettext('Pending OCR'),
                      value: null
                    },
                    {
                      text: this.$gettext('Automatic'),
                      value: 'automatic'
                    },
                    {
                      text: this.$gettext('Need Review'),
                      value: 'manual'
                    },
                    {
                      text: this.$gettext('Reviewed'),
                      value: 'reviewed'
                    }
                  ]
                }
              }
            }
          }
        ],
        extraActions: [
          {
            label: '',
            type: () => import('@/components/ShippingFiles/ListItemActions'), // external bunch of actions
            props: (item) => {
              return {
                item: item
              }
            }
          },
          {
            type: 'b-dropdown-divider',
            position: 'start'
          }
        ],
        includes: [
          'applied_by',
          'shipping'
        ],
        exclude: [
          'meta'
        ]
      }
    }
  }
}
